module.exports = __webpack_public_path__ + "static/media/rapidNaming-intro3.f8c895ec.mp3";